import { render, staticRenderFns } from "./QRMessage.vue?vue&type=template&id=f61d0f6c&"
import script from "./QRMessage.vue?vue&type=script&lang=js&"
export * from "./QRMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports